import layout from '@views/layout/index.vue';

const walkthroughRoutes = [
  {
    path: '/gp',
    name: 'nav',
    component: layout,
    children: [
      {
        path: 'welfare',
        name: 'welfare', // 首页
        meta: {
          pageType: 'welfare',
          pageName: '福利',
          keepAlive: true,
        },
        component: () => import(/* webpackChunkName: "welfare" */ '@views/welfare/index/index.vue'),
      },
      {
        path: 'calendar',
        name: 'index-calendar', // 日历
        meta: {
          pageType: 'index-calendar',
          pageName: '活动日历',
          keepAlive: true,
        },
        component: () => import(/* webpackChunkName: "calendar" */ '@views/welfare/calendar/index/index.vue'),
      },
    ],
  },
];
function addMeta(walkthroughRoute) {
  walkthroughRoute.children.forEach((route) => {
    if (route.children) {
      addMeta(route);
      return;
    }
    route.meta && (route.meta.sideBar = 'welfare');
  });
}
addMeta(walkthroughRoutes[0]);

export default walkthroughRoutes;
